export function SectionHeading({ eyebrow, title, copy, light = false, align = "left", testId }) {
  return (
    <header className={`section-heading section-heading--${align} ${light ? "section-heading--light" : ""}`} data-testid={testId}>
      <p className="eyebrow" data-testid={`${testId}-eyebrow`}>{eyebrow}</p>
      <h2 data-testid={`${testId}-title`}>{title}</h2>
      {copy && <p className="section-copy" data-testid={`${testId}-copy`}>{copy}</p>}
    </header>
  );
}